// ランタイムのテーマ状態（③ ダークモード）。
// 実効スキーム = ユーザーのトグル override（最優先）→ app.brand.base → auto はシステム設定。
// override は localStorage に保存（端末ごと・アプリ横断のユーザー設定）。model.mjs の resolveMode が純関数の判定本体。
import { signal } from "@preact/signals";
import { resolveMode } from "./model.mjs";

const OVERRIDE_KEY = "sheetsnap:theme"; // "light" | "dark"（無ければ app 設定/システムに従う）

function readOverride(): "light" | "dark" | null {
  try {
    const v = localStorage.getItem(OVERRIDE_KEY);
    return v === "light" || v === "dark" ? v : null;
  } catch {
    return null;
  }
}

/** ユーザーが明示選択したスキーム（null=未選択＝app/システムに従う）。 */
export const themeOverrideSig = signal<"light" | "dark" | null>(readOverride());

/** OS のダーク設定（auto 判定に使う）。 */
export const systemDarkSig = signal<boolean>(
  typeof matchMedia !== "undefined" && matchMedia("(prefers-color-scheme: dark)").matches
);

/** システムのカラースキーム変化を監視（main.tsx で1回）。 */
export function bindTheme(): void {
  if (typeof matchMedia === "undefined") return;
  const mq = matchMedia("(prefers-color-scheme: dark)");
  const onChange = (e: MediaQueryListEvent) => (systemDarkSig.value = e.matches);
  mq.addEventListener?.("change", onChange);
}

/** app.brand.base とシグナルから実効スキームを算出。 */
export function currentMode(appBase?: "light" | "dark" | "auto"): "light" | "dark" {
  return resolveMode(appBase, systemDarkSig.value, themeOverrideSig.value);
}

/** ヘッダーのトグル: 今のスキームを反転してユーザー override として保存。 */
export function toggleTheme(current: "light" | "dark"): void {
  const next = current === "dark" ? "light" : "dark";
  themeOverrideSig.value = next;
  try {
    localStorage.setItem(OVERRIDE_KEY, next);
  } catch {
    /* 保存不可でも動作に影響なし（今セッションのみ有効） */
  }
}
